var Timeline = require('./timeline');
var Screen = require('./screen');

var App = function (options) {
  options = options || {};
  this.options = options;
  this.options.interval = options.interval || 15;
  this.datas = [];
  this.init();
  this.sends = [];
};

App.prototype = {
  init: function () {
    this.sc = new Screen(this.options);
    this.tm = new Timeline();
    this.initEvent();
  },
  initEvent: function () {
    var tm = this.tm;
    var sc = this.sc;
    tm.addStepCallBack(function (fgs, spend) {
        sc.clear();
        for(var i = 0, iLen = fgs.length; i < iLen; i++) {
            var fg = fgs[i];
            fg.updateSpend(spend);
            // console.log(fgs[i].getCurrentPosition());
            sc.render(fg);
            if (sc.isOut(fg)) {
              fg.del = true;
            }
        }

        for(var i = fgs.length; i > 0; i--) {
            var fg = fgs[i - 1];
            if (fg.del == true) {
                tm.remove(fg);
                sc.remove(fg);
            }
        }

        var row = sc.checkRow();
        if (row != null && this.datas.length > 0) {
            var data = this.datas.shift();
            tm.add(sc.createFragment(data, row))
        }
    }.bind(this));

    // this.video.addEventListener('pause', function() {
    //   this.tm.pause();
    // }.bind(this))

    // this.video.addEventListener('play', function() {
    //   if (this.tm.status == 1) {
    //     this.tm.start();
    //   } else {
    //     this.tm.play();
    //   }
    // }.bind(this))

  },

  fliterDatasBySend: function (datas) {
    var result = [];
    var item;
    for (var i = 0, iLen = datas.length; i < iLen; i++) {
      item = datas[i];
      var isSelect = false;
      for (var j = 0, jLen = this.sends.length; j < jLen; j++) {
        if (this.sends[j].content == item.content) {
          this.sends.splice(j, 1);
          isSelect = true;
          break;
        }
      }
      if (!isSelect) {
        result.push(item);
      }
    }
    return result;
  },

  contain: function (item) {
    for (var i = 0, iLen = this.datas.length; i < iLen; i++) {
      if (item.id == this.datas[i].id) {
        return true;
      }
    }

    for (var i = 0, iLen = this.tm.fragments.length; i < iLen; i++) {
      if (item.id == this.tm.fragments[i].options.id) {
        return true;
      }
    }

    return false;
  },

  fliterDatas: function (datas) {
    datas = this.fliterDatasBySend(datas);
    var result = [];
    for (var i = 0, iLen = datas.length; i < iLen; i++) {
      if (datas[i].id.indexOf('sendBack_') >=0) {
        this.sends.push(datas[i]);
      }
      if (!this.contain(datas[i])) {
        result.push(datas[i]);
      }
    }
    return result;
  },

  getData: function (list) {
    this.datas = this.datas.concat(this.fliterDatas(list));
  },

  start: function () {
    this.tm.start();
    this.datas = [];
  },
  pause: function () {
    this.tm.pause();
  },
  continue: function () {
    this.tm.play();
  },
  end: function () {
    this.tm.end();
    this.sc.clear();
    this.sc.removeAll();
  },
  resize: function () {
    this.sc.resize();
  },
  hide: function () {
    this.sc.hide();
  },
  show: function () {
    this.sc.show();
  },
  renderTo : function (parentNode) {
    this.sc.renderTo(parentNode);
  }
};

module.exports = App;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/canvas/index.js